import { type TaskView, type WorkflowCategory } from '@apm/contracts';

type Flags = Pick<TaskView, 'canMove' | 'canComplete'>;

/**
 * Người đang xem đổi được task này từ nhóm `from` sang nhóm `to` không —
 * APM-TSP-d. Đọc hai cờ server đã tính bằng `canMoveTask`/`canCompleteTask`
 * (contracts), nên web không viết lại luật lần thứ hai.
 *
 * Cờ vắng mặt (`undefined`) thì coi như **được**, cùng quy ước với `canEdit`:
 * khoá nhầm người có quyền tệ hơn, và server vẫn là cửa thật.
 */
export function canMoveBetween(task: Flags, from: WorkflowCategory, to: WorkflowCategory): boolean {
  if (task.canMove === false) return false;
  if ((from === 'done' || to === 'done') && task.canComplete === false) return false;
  return true;
}
